module.exports = __webpack_public_path__ + "media/images/tl/banner/th-2-light-4a7a9fa449907661264f2eddf34acc73.jpg";